export const IMG = {
  // Official brand assets (extracted from the master PDF, transparent PNGs)
  logoInk: "/brand/logo-full-ink.png", // dark logo for light backgrounds
  logoBone: "/brand/logo-full-bone.png", // cream logo for dark backgrounds
  markInk: "/brand/mark-ink.png?v=2", // -H- monogram, dark
  markBone: "/brand/mark-bone.png?v=2", // -H- monogram, cream
  // High-res hero: Black Angus herd grazing at sunset with the Bitterroots
  heroHerdSunset:
    "https://customer-assets-jai6qajn.emergentagent.net/job_hideaway-seed-stock/artifacts/kgbt6z53_IMG_7216.webp",
  // High-res golden sun cresting the mountains over the hay field
  goldenSun:
    "https://customer-assets-jai6qajn.emergentagent.net/job_hideaway-seed-stock/artifacts/ug0mhk4j_IMG_3204.webp",
  // Ultra-wide fiery sunset panorama over the valley (letterbox band)
  panoramaSunset:
    "https://customer-assets-jai6qajn.emergentagent.net/job_hideaway-seed-stock/artifacts/46i5nt5c_IMG_3009.webp",
  // Black Angus seedstock herd lying in green Bitterroot pasture (3:4)
  seedstockHerd:
    "https://customer-assets-jai6qajn.emergentagent.net/job_hideaway-seed-stock/artifacts/udy0nt8j_515508399_23933736012901422_8548145458807938957_n.webp",
  // Registered Angus cow in autumn, golden cottonwoods behind (tag 65)
  angusAutumn:
    "https://customer-assets-jai6qajn.emergentagent.net/job_hideaway-seed-stock/artifacts/bie04s3j_IMG_8594.webp",
  // Dramatic sunrise/sunset over the Bitterroots with wheel-line sprinklers
  sunsetSprinklers:
    "https://customer-assets-jai6qajn.emergentagent.net/job_hideaway-seed-stock/artifacts/1g2barwr_IMG_7844.webp",
  // Black Angus calf bedded in tall grass (tag 68)
  calfInGrass:
    "https://customer-assets-jai6qajn.emergentagent.net/job_hideaway-seed-stock/artifacts/6ekm53sy_IMG_7697.webp",
  // Wheel-line irrigation with snow-capped Bitterroot peaks + blue sky (tall)
  wheelLinePeaks:
    "https://customer-assets-jai6qajn.emergentagent.net/job_hideaway-seed-stock/artifacts/1sfaccte_64460162567__5D1548A8-697C-4EDE-BFA8-FD41E55F118F.fullsizerender.webp",
  // Wide Bitterroot pasture vista, ranch buildings + clouds (rotation-corrected, local)
  pastureVista: "/photos/pasture-vista.webp",
  // Real people & progeny photos
  johnAndJennifer:
    "https://customer-assets-jai6qajn.emergentagent.net/job_hideaway-seed-stock/artifacts/jzsswifa_John%20%26%20Jennifer.jpg",
  johnShowRing:
    "https://customer-assets-jai6qajn.emergentagent.net/job_hideaway-seed-stock/artifacts/j3pptzb5_John.webp",
  confluenceHeifers:
    "https://customer-assets-jai6qajn.emergentagent.net/job_hideaway-seed-stock/artifacts/8ng583p2_Conflunce%20Heifers.jpg",
  // SUNSET pasture with herd + mountains (main hero shot)
  heroSunsetPasture:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_d022dcb1-d293-4899-9b96-fef4740172d4/artifacts/d2bwd062_480507188_9209660802402186_2440966124041179462_n.jpg",
  // The Quinns working the herd with a Charolais cow (rancher + wife interaction)
  quinnsAtWork:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_d022dcb1-d293-4899-9b96-fef4740172d4/artifacts/vnakk6l7_32105752_1682997721735236_6054342464884441088_n.jpg",
  // Baldy calf in front of the historic Hideaway barn (Angus operation)
  baldyCalfBarn:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_d022dcb1-d293-4899-9b96-fef4740172d4/artifacts/lisx97xp_486610369_9445811695453761_2057808144520156846_n.jpg",
  // The historic white heritage barn on a blue-sky day
  estateBarn:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_d022dcb1-d293-4899-9b96-fef4740172d4/artifacts/hhxgtml2_486650354_9447467531954844_384837472087471319_n.jpg",
  // Herd grazing at golden hour with mountain crepuscular rays (parallax band) — high-res
  parallaxGoldenHour:
    "https://customer-assets-jai6qajn.emergentagent.net/job_hideaway-seed-stock/artifacts/4fg5t9p3_713783930_27092251797049812_8516448948058751590_n.webp",
  // Yellow/white Charolais calf close portrait (rear-quarter view w/ ear tag 504)
  charolaisCalf:
    "https://customer-assets-jai6qajn.emergentagent.net/job_hideaway-seed-stock/artifacts/m7flbj86_515200396_23933736049568085_1157377597187453139_n.jpg",
  // Registered Angus heifer close portrait (black, in golden light with herd)
  angusHeifer:
    "https://customer-assets-jai6qajn.emergentagent.net/job_hideaway-seed-stock/artifacts/5fia5g18_502463771_9919239674777625_3736383997293944554_n.webp",
  // VDAR CONFLUENCE 4273 — flagship sire (professional show shot)
  flagshipBull:
    "https://customer-assets-jai6qajn.emergentagent.net/job_hideaway-seed-stock/artifacts/k4xs3std_598283543_25381928371415505_2624478162949661190_n.jpg",
  // 4273 at home — grazing in the Bitterroot Valley pasture, tag 4273 visible
  bullInPasture:
    "https://customer-assets-jai6qajn.emergentagent.net/job_hideaway-seed-stock/artifacts/dcby0odc_556084763_24689533710654978_914344980634471135_n.jpg",
  // Flagship Charolais cow — professional side profile, corral show shot
  charolaisFlagship:
    "https://customer-assets-jai6qajn.emergentagent.net/job_hideaway-seed-stock/artifacts/9rcd1sbb_581683189_25119814704293541_5413345093619395470_n.jpg",
};

export const FLAGSHIP = {
  id: "vdar-confluence-4273",
  name: "VDAR Confluence 4273",
  breed: "Black Angus",
  regNumber: "20672987",
  dob: "01 / 21 / 2023",
  sire: "U-2 Coalition 206C",
  dam: "VDAR Polly 9260",
  coOwners: [
    "Hideaway Cattle Company · Stevensville MT",
    "Van Dyke Angus Ranch · Manhattan MT",
  ],
  epds: [
    { k: "CED", v: 12, label: "Calving Ease Direct" },
    { k: "BW", v: 0.7, label: "Birth Weight" },
    { k: "WW", v: 67, label: "Weaning Weight" },
    { k: "YW", v: 123, label: "Yearling Weight" },
    { k: "MILK", v: 34, label: "Maternal Milk" },
    { k: "CEM", v: 6, label: "Calving Ease Maternal" },
    { k: "SC", v: 0.96, label: "Scrotal Circumference" },
    { k: "DOC", v: 23, label: "Docility" },
    { k: "CW", v: 54, label: "Carcass Weight" },
    { k: "MARB", v: 0.48, label: "Marbling" },
    { k: "REA", v: 0.33, label: "Ribeye Area" },
    { k: "$W", v: 72, label: "Weaned Calf Value" },
    { k: "$B", v: 137, label: "Beef Value" },
  ],
  commentary:
    "Confluence — where power, performance and true maternal value converge. Bred near the headwaters of the Missouri River, VDAR Confluence unites the unwavering maternal focus of the Van Dyke program with the shape, structure and true performance of Coalition. Deep, thick, structurally complete and gentle in disposition, Confluence offers an outcross pedigree that creates rare mating flexibility for the modern seedstock breeder.",
  certificatePrice: 40,
};

// Registered Confluence 4273 daughters — replacement heifers offered
export const CONFLUENCE_DAUGHTERS = [
  {
    lot: "Lot 13",
    name: "Hideaway Donna 502",
    reg: "AAA # 21307598",
    dob: "02 / 08 / 2025",
    sire: "VDAR Confluence 4273",
    dam: "Coleman Donna 0419",
  },
  {
    lot: "Lot 14",
    name: "Hideaway Donna 503",
    reg: "AAA # [reg here]",
    dob: "02 / 08 / 2025",
    sire: "VDAR Confluence 4273",
    dam: "Coleman Donna 0419",
  },
];
